// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"BelowTheFoldPlaceholder_placeholder__v_h1B"};